import * as e from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/CaretLineUp.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: n }));
o.displayName = "CaretLineUpIcon";
const p = o;
export {
  p as CaretLineUp,
  o as CaretLineUpIcon
};
